'use client'

import React, { useEffect } from 'react'
import { useTranslations } from 'next-intl'

import type { HolidayCollectionIndexEntry } from '@/src/types/holidays'
import useHolidaysGtmEvent from '@/src/hooks/analytics/gtm/holidays'
import useClevertapForHolidays from '@/src/hooks/analytics/clevertap/holidays'
import useHolidayAppMode from '@/src/hooks/holidays/useHolidayAppMode'
import { HOLIDAY_ACTION } from '@/src/utils/analytics/holidays/holidayEvents'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'

import HolidayIndexPage from './indexRootLoader'

interface HolidayIndexRootLoaderProps {
    entries: HolidayCollectionIndexEntry[]
    isMobile: boolean
    domainCountry: string
}

const HolidayIndexRootLoader: React.FC<HolidayIndexRootLoaderProps> = ({ entries, isMobile, domainCountry }) => {
    const { pushHolidayListPageViewEvent } = useHolidaysGtmEvent()
    const { triggerHolidayPageLoadEvent } = useClevertapForHolidays()
    const t = useTranslations('holidaysPage')
    const isApp = useHolidayAppMode()

    // Once per load; the landing page has no slug of its own.
    useEffect(() => {
        pushHolidayListPageViewEvent('holidays')
        // No provider on this route, so the market the page was served for is passed in.
        triggerHolidayPageLoadEvent(HOLIDAY_ACTION.INDEX_VIEWED, {
            market: domainCountry || 'NA',
            collection_count: entries.length
        })
    }, [])

    return (
        <ErrorBoundaryWrapper identifier="holidays-index">
            <HolidayIndexPage
                entries={entries}
                isMobile={isMobile}
                domainCountry={domainCountry}
                isApp={isApp}
                appTitle={t('indexHeading')}
            />
        </ErrorBoundaryWrapper>
    )
}

export default HolidayIndexRootLoader
